import React from "react";
import styled, { css } from "styled-components";
import getConfig from "next/config";
import { theme } from "../../../theme";
const { devices } = theme;
const { publicRuntimeConfig } = getConfig();

const StyledBasicHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;

  width: 100%;

  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 24px;
  padding-right: 24px;

  ${({ secondary }) => secondary && css`
    padding-top: 34px;
    padding-bottom: 34px;
  `}

  &::before {
    content: '';
    display: block;
    position: absolute;

    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    
    z-index: -1;

    ${({ secondary }) => secondary && css`
      opacity: 0;
    `}
  }

  .product-header-title {
    font-family: 'MerriweatherBold';
    font-size: 44px;
    line-height: 74px;
    text-align: center;
    text-transform: capitalize;
    color: #078FF1;
    text-shadow: 1px 1px 0px #FFFFFF;
  }

  .product-header-subtitle {
    font-family: 'MerriweatherLight';
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    text-transform: capitalize;
    color: #000000;

    ${({ secondary }) => secondary && css`
      margin-top: 8px;
      font-size: 18px;
      line-height: 26px;
    `}
  }

  @media ${devices.tablet} {
    padding-top: 28px;
    padding-bottom: 28px;

    .product-header-title {
      margin-bottom: 10px;
      font-size: 26px;
      line-height: 33px;
    }

    .product-header-subtitle {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

function BasicHeaderSection({ title, subtitle, secondary }) {
  return (
    <StyledBasicHeaderSection secondary={secondary}>
      <div className="product-header-title">
        <span>{title}</span>
      </div>
      <div className="product-header-subtitle">
        <span>{subtitle}</span>
      </div>
    </StyledBasicHeaderSection>
  );
}

export default BasicHeaderSection;
